import './AddRemoveButton.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlusSquare,
  faMinusSquare,
  faSquare,
} from '@fortawesome/free-solid-svg-icons';

/* eslint-disable react/prop-types */
export default function AddRemoveButton({ type, text, onClick }) {
  return (
    <button type="button" className="add-remove-button" onClick={onClick}>
      <FontAwesomeIcon
        className={`button-icon ${
          type === 'remove' ? 'remove-button' : 'add-button'
        }`}
        icon={
          type === 'remove'
            ? faMinusSquare
            : type === 'add'
            ? faPlusSquare
            : faSquare
        }
      />
      <p className="button-text">{text}</p>
    </button>
  );
}
